import { LocaleInput } from '../index.js'

export default {
  code: 'ug',
  buttonText: {
    month: 'ئاي',
    week: 'ھەپتە',
    day: 'كۈن',
    list: 'كۈنتەرتىپ',
  },
  allDayText: 'پۈتۈن كۈن',
} as LocaleInput
